export default __webpack_public_path__ + "static/media/bannerLightBackgroundImg.2362bd56.png";